/* eslint-disable max-classes-per-file */
/* eslint-disable no-useless-constructor */
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

import {
  EVENT_BOTTOM_SHEET_COLLAPSED_CTA_CLICK,
  EVENT_BOTTOM_SHEET_CTA_CLICK,
  EVENT_BOTTOM_SHEET_DISMISSED,
  EVENT_BOTTOM_SHEET_SHOW,
  EVENT_CONFIRMATION_TOAST_SHOW,
} from './constants';

/**
 * `session_id` carries the `rover_cid` common identifier — the same key that is
 * joined to `person_id` server-side (PersonSessionMapping) and that Statsig
 * buckets on. This is what makes the funnel
 * (anonymous visit → signup → coupon issue → redemption) joinable end-to-end.
 */
type SessionProps = { session_id?: string };
type ConfirmationProps = SessionProps & { person_id?: string };

abstract class MetaDiscountAnalyticsEvent extends AnalyticsEvent {
  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.marketing.referrals;
}

/** Fires when the $20 offer bottom sheet is shown to a variant visitor. */
export class MetaDiscountBottomSheetShow extends MetaDiscountAnalyticsEvent {
  eventName = EVENT_BOTTOM_SHEET_SHOW;

  constructor(eventProperties: SessionProps) {
    super(eventProperties);
  }
}

/** Fires when the visitor dismisses the bottom sheet (it collapses to the mini-banner). */
export class MetaDiscountBottomSheetDismissed extends MetaDiscountAnalyticsEvent {
  eventName = EVENT_BOTTOM_SHEET_DISMISSED;

  constructor(eventProperties: SessionProps) {
    super(eventProperties);
  }
}

/** Fires when the visitor clicks the sign-up CTA on the full bottom sheet. */
export class MetaDiscountBottomSheetCtaClick extends MetaDiscountAnalyticsEvent {
  eventName = EVENT_BOTTOM_SHEET_CTA_CLICK;

  constructor(eventProperties: SessionProps) {
    super(eventProperties);
  }
}

/** Fires when the visitor clicks the sign-up CTA on the collapsed mini-banner. */
export class MetaDiscountBottomSheetCollapsedCtaClick extends MetaDiscountAnalyticsEvent {
  eventName = EVENT_BOTTOM_SHEET_COLLAPSED_CTA_CLICK;

  constructor(eventProperties: SessionProps) {
    super(eventProperties);
  }
}

/** Fires when the post-signup green confirmation banner is shown. */
export class MetaDiscountConfirmationToastShow extends MetaDiscountAnalyticsEvent {
  eventName = EVENT_CONFIRMATION_TOAST_SHOW;

  constructor(eventProperties: ConfirmationProps) {
    super(eventProperties);
  }
}
